<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje evidence opravljenega dela</span>
                    <span v-if="!editMode">Dodajanje zapisa v evidenco opravljenega dela</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <b-form-group id="selectedUser"
                              label="Izberi osebo"
                              label-for="selectedUser"
                              :class="{'is-invalid': errors.has('selectedUser')}">

                    <v-select
                            v-model="workHoursReport.userId"
                            id="selectedUser"
                            name="selectedUser"
                            label="last_name"
                            :options="users"
                            :disabled="readonly"
                            :reduce="item => item.id"
                            v-validate="'required'"
                    >
                        <span slot="no-options">Ni zadetkov.</span>

                        <template slot="option" slot-scope="item">
                            {{ getOptionLabel(item) }}
                        </template>

                        <template slot="selected-option" slot-scope="item">
                            {{ getOptionLabel(item) }}
                        </template>
                    </v-select>
                    <div class="invalid-feedback" v-if="errors.has('selectedUser')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>


                <b-form-group
                        label="Izberi datum"
                        label-for="date"
                        :class="{'is-invalid': errors.has('date')}">

                    <VueCtkDateTimePicker id="date" name="date" format="YYYY-MM-DDTHH:mm:ssZ" class="withLabel"
                                          locale="sl"
                                          formatted="dddd, Do MMMM YYYY" :onlyDate="true"
                                          label="Datum"
                                          :disabled="readonly"
                                          :noClearButton="readonly"
                                          :class="readonly ? 'disabled' : ''"
                                          v-model="workHoursReport.date"
                                          v-validate="'required'"/>
                    <div class="invalid-feedback" v-if="errors.has('date')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>

              <b-form-group
                  label="Tip"
                  label-for="type"
                  :class="{'is-invalid': errors.has('type')}">
                <v-select
                    v-model="workHoursReport.type"
                    id="type"
                    name="type"
                    :disabled="readonly"
                    :class="readonly ? 'disabled' : ''"
                    :options="['redno delo', 'letni dopust', 'praznik', 'bolniški dopust', 'beleženje nadur', 'koriščenje nadur', 'izobraževanje', 'neplačan dopust', 'drugo']"
                    @input="handleTypeChange"
                    v-validate="'required'"
                >
                </v-select>
                <div class="invalid-feedback" v-if="errors.has('type')">
                  Polje ne sme biti prazno.
                </div>
              </b-form-group>

                <!-- Time fields for regular work types -->
                <div v-if="workHoursReport.type !== 'koriščenje nadur'">
                    <b-form-group
                            label="Ura prihoda na delo"
                            label-for="start"
                            :class="{'is-invalid': errors.has('start')}">

                        <VueCtkDateTimePicker id="start" name="start" format="HH:mm" class="withLabel" locale="sl"
                                              :autoClose="false"
                                              formatted="HH:mm" :onlyTime="true" :minuteInterval="10"
                                              label="Prihod na delo" @input="calculateDuration()"
                                              :disabled="readonly"
                                              :noClearButton="readonly"
                                              :class="readonly ? 'disabled' : ''"
                                              v-model="workHoursReport.startTime"
                                              v-validate="workHoursReport.type !== 'koriščenje nadur' ? 'required' : ''"/>
                        <div class="invalid-feedback" v-if="errors.has('start')">
                            Polje ne sme biti prazno.
                        </div>
                    </b-form-group>

                    <b-form-group
                            label="Ura odhoda z delo"
                            label-for="end"
                            :class="{'is-invalid': errors.has('end')}">

                        <VueCtkDateTimePicker id="end"
                                              name="end" format="HH:mm" class="withLabel" locale="sl"
                                              :autoClose="false"
                                              formatted="HH:mm" :onlyTime="true" :minuteInterval="10"
                                              label="Odhod z dela" @input="calculateDuration()"
                                              :disabled="readonly"
                                              :noClearButton="readonly"
                                              :class="readonly ? 'disabled' : ''"
                                              v-model="workHoursReport.endTime"
                                              v-validate="workHoursReport.type !== 'koriščenje nadur' ? 'required' : ''"/>
                        <div class="invalid-feedback" v-if="errors.has('end')">
                            Polje ne sme biti prazno.
                        </div>
                    </b-form-group>

                    <b-form-group
                            id="duration"
                            label="Trajanje"
                            label-for="duration">
                        <b-form-input id="duration" v-model="workHoursReport.duration" placeholder="trajanje" trim
                                      disabled></b-form-input>
                    </b-form-group>
                </div>

                <!-- Direct hour input for overtime usage -->
                <div v-if="workHoursReport.type === 'koriščenje nadur'">
                    <b-form-group
                            label="Število ur za koriščenje"
                            label-for="overtimeHours"
                            :class="{'is-invalid': errors.has('overtimeHours')}">
                        <v-select
                                v-model="selectedOvertimeHours"
                                id="overtimeHours"
                                name="overtimeHours"
                                :disabled="readonly"
                                :class="readonly ? 'disabled' : ''"
                                :options="overtimeHourOptions"
                                @input="setOvertimeDuration"
                                v-validate="workHoursReport.type === 'koriščenje nadur' ? 'required' : ''"
                        >
                        </v-select>
                        <div class="invalid-feedback" v-if="errors.has('overtimeHours')">
                            Polje ne sme biti prazno.
                        </div>
                    </b-form-group>
                </div>

                <b-form-group
                        label="Opiši naloge oz. opravljeno delo"
                        label-for="summary"
                        :class="{'is-invalid': errors.has('summary')}">
                            <textarea v-model="workHoursReport.summary" id="summary"
                                      name="summary"
                                      placeholder="opis opravljenih nalog oz. opravljenega dela"
                                      class="form-control" style="height: auto"
                                      :disabled="readonly"
                                      :class="readonly ? 'disabled' : ''"
                                      required rows="5"
                                      v-validate="'required'"> </textarea>
                    <div class="invalid-feedback" v-if="errors.has('summary')">
                        Polje ne sme biti prazno.
                    </div>
                </b-form-group>


            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteWorkHoursReportConfirmation()">
                        <i class="fa fa-trash"></i>
                        Izbriši
                        zapis
                    </button>

                    <button v-if="!editMode" type="submit" @click="addWorkHoursReport()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke
                    </button>


                    <button v-if="editMode" type="submit" @click="updateWorkHoursReport()" class="btn btn-info ml-auto">
                        <i
                                class="fa fa-save"></i> Posodobi podatke
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'AdminWorkHoursReport'}" class="btn btn-link pt-4">
                    Prekliči
                    </router-link>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'EditProject',
    components: {
      vSelect
    },
    data () {
      return {
        users: this.$store.getters.getUsers,
        workHoursReport: {
          id: '',
          userId: '',
          date: null,
          startTime: null,
          endTime: null,
          duration: '',
          type: '',
          summary: '',
          updatedAt: null,
          createdAt: null
        },
        id: this.$route.params.id,
        readonly: this.$route.params.readonly,
        editMode: false,
        selectedOvertimeHours: null,
        overtimeHourOptions: [
          '0:15', '0:30', '0:45', '1:00', '1:15', '1:30', '1:45', '2:00',
          '2:15', '2:30', '2:45', '3:00', '3:15', '3:30', '3:45', '4:00',
          '4:15', '4:30', '4:45', '5:00', '5:15', '5:30', '5:45', '6:00',
          '6:15', '6:30', '6:45', '7:00', '7:15', '7:30', '7:45', '8:00'
        ]
      }
    },

    watch: {
      // Watch for changes in the type field to handle the UI accordingly
      'workHoursReport.type': function(newValue) {
        if (newValue === 'koriščenje nadur' && !this.selectedOvertimeHours) {
          this.selectedOvertimeHours = '1:00';
          this.setOvertimeDuration();
        }
      }
    },

    mounted () {
      const _this = this;

      if (_this.$store.getters.getUsers.length === 0) {
        _this.$store.dispatch('retrieveUsers').then(() => {
          _this.users = _this.$store.getters.getUsers

        })
      }

      if (this.id) {
        this.editMode = true
        this.retrieveWorkHoursReport()
      } else {
        this.editMode = false
        this.workHoursReport.date =  this.$route.params.date ? this.moment(this.$route.params.date).format('YYYY-MM-DDTHH:mm:ssZ') : this.moment().format('YYYY-MM-DDTHH:mm:ssZ');
        this.workHoursReport.startTime = this.moment().set({hour: 8, minute: 0}).format('HH:mm')
        this.workHoursReport.endTime = this.moment().set({hour: 16, minute: 0}).format('HH:mm')
        this.workHoursReport.type = 'redno delo'
        
        // Use the currently selected user from the store for new entries
        // If not available, fall back to the logged-in user
        const currentlySelectedUser = this.$store.getters.getCurrentlySelectedUser;
        if (currentlySelectedUser) {
          console.log('Using currently selected user for new entry:', currentlySelectedUser);
          this.workHoursReport.userId = currentlySelectedUser;
        } else {
          // Fallback to the logged-in user
          console.log('No user selected in store, using current user');
          this.workHoursReport.userId = JSON.parse(sessionStorage.getItem('DP_user')).id;
        }
        
        this.calculateDuration()
      }

      console.log('workHoursReport ->', this.workHoursReport)

    },
    methods: {

      getOptionLabel (option) {
        //console.log(option);
        return this.getReadableUser(option.id)
      },

      retrieveWorkHoursReport () {
        const _this = this

        db.collection('workHoursReports')
          .doc(this.id)
          .get()
          .then(snapshot => {
            const document = snapshot.data()

            _.forOwn(document, function (value, key) {
              if (key === 'date') {
                document[key] = _this.moment.unix(value.seconds).format('YYYY-MM-DDTHH:mm:ssZ')
              } else if (key === 'startTime' || key === 'endTime') {
                document[key] = _this.moment.unix(value.seconds).format('HH:mm')
              }
            })

            _this.workHoursReport = document

            // If this is an overtime usage record, set the selected hours
            if (document.type === 'koriščenje nadur') {
              _this.selectedOvertimeHours = document.duration;
            }
          })
      },

      updateWorkHoursReport (id) {
        const _this = this
        const currentWorkHoursReport = db.collection('workHoursReports').doc(this.id)

        this.$validator.validate().then(result => {
          if (result) {
            // Different handling for overtime usage vs regular entries
            if (_this.workHoursReport.type === 'koriščenje nadur') {
              // For overtime usage, we don't record start/end times
              return currentWorkHoursReport.update({
                date: _this.moment(_this.workHoursReport.date).toDate(),
                updatedAt: new Date(),
                createdAt: _this.workHoursReport.createdAt,
                userId: _this.workHoursReport.userId,
                // Use a standard time (8:00) for record-keeping, but the actual hours used are in duration
                startTime: _this.moment().set({hour: 8, minute: 0}).toDate(),
                endTime: _this.moment().set({hour: 8, minute: 0}).toDate(),
                duration: _this.workHoursReport.duration,
                type: _this.workHoursReport.type,
                summary: _this.workHoursReport.summary
              })
              .then(function () {
                _this.$router.push({name: 'AdminWorkHoursReport'})
              })
              .catch(function (error) {
                console.error('Error updating work hour report: ', error)
              })
            } else {
              // Regular entry with start/end times
              return currentWorkHoursReport.update({
                date: _this.moment(_this.workHoursReport.date).toDate(),
                updatedAt: new Date(),
                createdAt: _this.workHoursReport.createdAt,
                userId: _this.workHoursReport.userId,
                startTime: _this.moment(_this.workHoursReport.startTime, 'HH:mm').toDate(),
                endTime: _this.moment(_this.workHoursReport.endTime, 'HH:mm').toDate(),
                duration: _this.workHoursReport.duration,
                type: _this.workHoursReport.type,
                summary: _this.workHoursReport.summary
              })
              .then(function () {
                _this.$router.push({name: 'AdminWorkHoursReport'})
              })
              .catch(function (error) {
                console.error('Error updating work hour report: ', error)
              })
            }
          } else {
            _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true});
          }
        })
      },

      addWorkHoursReport () {
        const _this = this

        this.$validator.validate().then(result => {
          console.log("result", result)
          if (result) {
            // If this is an overtime usage record, make sure we have the correct duration
            if (_this.workHoursReport.type === 'koriščenje nadur' && _this.selectedOvertimeHours) {
              _this.workHoursReport.duration = _this.selectedOvertimeHours;
            }

            let ref = db.collection('workHoursReports').doc()
            ref.set({id: ref.id}) // set new document ID
              .then(() => {  // fetch the doc again and show its data
                ref.get().then(doc => {
                  _this.id = doc.data().id
                  _this.workHoursReport.createdAt = new Date()
                  _this.updateWorkHoursReport()
                })
              })
          } else {
            _this.$swal('Manjkajoči podatki', 'Preverite, če ste vnesli vse potrebne podatke!', 'error', {dangerMode: true});
          }
        })
      },
      deleteWorkHoursReportConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati ta zapis? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteWorkHoursReport()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteWorkHoursReport () {
        const _this = this

        db.collection('workHoursReports').doc(_this.id).delete()
          .then(function () {
            _this.$router.push({name: 'AdminWorkHoursReport'})
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting work hour report: ', error)
          })
      },
      calculateDuration () {
        const _this = this

        if (_this.workHoursReport.type === 'koriščenje nadur') {
          return; // Skip for overtime usage type
        }

        let startTime = _this.moment(_this.workHoursReport.startTime, 'HH:mm')
        let endTime = _this.moment(_this.workHoursReport.endTime, 'HH:mm')

        _this.workHoursReport.endTime = endTime
        _this.workHoursReport.startTime = startTime

        console.log('startTime ', startTime)
        console.log('endTime ', endTime)

        _this.workHoursReport.duration = _this.moment.duration(_this.moment(endTime).diff(_this.moment(startTime))).format('HH:mm'), 'hours'
      },

      handleTypeChange(type) {
        const _this = this;

        if (type === 'koriščenje nadur') {
          // For overtime usage, we need to clear the start/end times and set a default duration
          _this.workHoursReport.startTime = null;
          _this.workHoursReport.endTime = null;
          _this.selectedOvertimeHours = '1:00'; // Default to 1 hour
          _this.setOvertimeDuration();
        } else if (type !== 'koriščenje nadur' && !_this.workHoursReport.startTime) {
          // When switching back to regular types, restore default times if they're empty
          _this.workHoursReport.startTime = _this.moment().set({hour: 8, minute: 0}).format('HH:mm');
          _this.workHoursReport.endTime = _this.moment().set({hour: 16, minute: 0}).format('HH:mm');
          _this.calculateDuration();
        }
      },

      setOvertimeDuration() {
        const _this = this;

        if (_this.selectedOvertimeHours) {
          _this.workHoursReport.duration = _this.selectedOvertimeHours;
        }
      },
      getReadableUser (userId) {
        const _this = this

        let userObj = _.filter(_this.users, {'id': userId})[0]
        if (userObj) {
          return userObj.first_name + ' ' + userObj.last_name
        } else {
          return 'n/a'
        }
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/EditWorkHoursReport.vue